import { VideoCarousel } from "../../../components/homeowner-user-landing-page/video-carousel";
import { reorderVideosByRequestedPattern } from "../../../components/homeowner-user-landing-page/reorder-videos";
import { testimonials } from "../../smart-guild-landing-page/data";

const carouselVideos = testimonials.videos.map((video) => ({
  title: video.title,
  description: "",
  videoBanner: video.thumbnail,
  url: video.url,
}));

const orderedCarouselVideos = reorderVideosByRequestedPattern(carouselVideos);

export const PerspectiveSection = () => {
  return (
    <section className="test-section">
      <div className="perspective-head fi">
        <div className="ey ey-c">HGD Perspective</div>
        <h2 className="st" style={{ marginBottom: "16px" }}>
          The relationship
          <br />
          <em>changes everything.</em>
        </h2>
        <p className="lead perspective-sub">
          Listen to what our interior designers and homeowners are saying about
          HDG.
        </p>
      </div>

      <div className="fi perspective-carousel-wrap">
        <VideoCarousel videos={orderedCarouselVideos} />
      </div>
    </section>
  );
};
